import { safeFetch } from 'lib/requests/fetch';
import { UserInteraction } from './types';

interface ICreateNewRedirectLinkInteractionPayload {
  linkTo: string;
  slideId: number;
}

export const createRedirectLinkInteraction = (
  payload: ICreateNewRedirectLinkInteractionPayload
) =>
  safeFetch('/tracking/redirect_link/interaction', {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export const updateRedirectLinkInteraction = (interactionId: string) =>
  safeFetch(`/tracking/redirect_link/${interactionId}/redirect`, {
    method: 'POST',
  });

interface ICreateNewSalesLinkInteractionPayload {
  trainingPreviewSessionId: string;
  interaction: string;
  nudgeId?: number;
}

export const createSalesLinkInteraction = (
  payload: ICreateNewSalesLinkInteractionPayload
) =>
  safeFetch('/tracking/sales_link/interaction', {
    method: 'POST',
    body: JSON.stringify(payload),
  });

interface ICreateNewSalesLinkInteractionsPayload {
  trainingPreviewSessionId: string;
  interaction: string;
  nudgeIds: number[];
}

export const createSalesLinkInteractions = (
  payload: ICreateNewSalesLinkInteractionsPayload
) =>
  safeFetch('/tracking/sales_link/interactions', {
    method: 'POST',
    body: JSON.stringify(payload),
  });

interface ICreateNewSalesLinkSessionPayload {
  previewLinkKey: string;
  browserVendor?: string;
  browserLanguage?: string;
  browserPlatform?: string;
}

export const createSalesLinkSession = (
  payload: ICreateNewSalesLinkSessionPayload
) =>
  safeFetch('/tracking/sales_link/session', {
    method: 'POST',
    body: JSON.stringify(payload),
  });

interface ICreateUserInteractionPayload {
  interaction: UserInteraction;
  interactionValue?: string;
  interactionValueOther?: string;
  sId?: number;
  se?: string;
  tId?: number;
  te?: string;
}

export const createUserInteraction = async (
  key: string,
  payload: ICreateUserInteractionPayload
) => {
  const keyUrl = key ? `?key=${key}` : '';
  const url = `/tracking/interactions${keyUrl}`;
  return safeFetch(url, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
};
